import { RequestMutationOptions } from '@approvalmax/data';
import { useMutate } from 'shared/data/api';

import { paymentsApiPaths } from '../paths';
import { CreatePaymentQuotes } from './useCreatePaymentQuotes.types';

/**
 * {uniqueId} should be {requestId}_{billId}. This pattern should be aligned w/ BE.
 * They use exactly that pattern atm.
 * {currency} - bill currency
 * {paymentDate} - Date.now()
 */
export const useCreatePaymentQuotes = (mutationOptions?: RequestMutationOptions<CreatePaymentQuotes>) => {
    return useMutate(paymentsApiPaths.quotes, {
        mutationOptions,
        apiSource: 'wallets',
        apiVersion: 'v1',
        method: 'post',
    });
};
